import { api } from "@/services";
import { useFilter } from "@/utilsV2";
async function useCorporate(cnpj: string) {
  const CNPJ = useFilter(cnpj, { type: "number" });
  // console.log("CEPEJOTÃO: ", CNPJ);
  let CorporateData = null;
  let CoporateError = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const resp = await api.get(`/Corporate/${CNPJ}`, {
        signal: Controller.signal
      });
      if (resp.status === 200) {
        CorporateData = resp.data;
      } else {
        CoporateError = ["Não foi possível encontrar o CNPJ informado"];
      }
    } catch (error) {
      CoporateError = ["Não foi possível carregar os dados da empresa", error.message];
    }
  };

  await MakeRequest();

  Controller.abort();

  return [CorporateData, CoporateError];
}

export { useCorporate };
